module.exports = __webpack_public_path__ + "img/V8.38544a90.png";